import React from 'react';
import {
  ListItem,
  ListItemAvatar,
  Avatar,
  makeStyles
} from '@material-ui/core';
import { FaqIcon } from 'app/main/components/icons';
import { HashLink as LinkTo } from 'react-router-hash-link';
import axios from 'api';
import { getMediaPreview, getMediaSource } from 'utils/mediaPreview';

const useStyles = makeStyles(theme => ({
  list: {
    padding: 0,
    borderBottom: '1px solid #0000001f',
    justifyContent: 'space-between'
  },
  fileName: {
    whiteSpace: 'nowrap',
    fontSize: '1.4rem',
    marginLeft: '3.33rem',
    textOverflow: 'ellipsis',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 5,
      fontSize: 12,
      whiteSpace: 'break-spaces'
    }
  },
  iconWrapper: {
    padding: '1rem',
    margin: '1rem',
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    fontSize: '1.5rem',
    borderRadius: '6px',
    border: '1px solid rgba(0, 0, 0, 0)',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
    '&:hover': {
      backgroundColor: '#debf81',
      color: 'white'
    },
    [theme.breakpoints.down('sm')]: {
      margin: 4,
      padding: 7
    }
  },
  avatar: {
    width: '3rem',
    height: '3rem',
    fontSize: '1.3rem',
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      width: '2rem',
      height: '2rem',
      fontSize: '0.8rem'
    }
  },
  avatarList: {
    padding: 10,
    minWidth: '3rem',
    marginRight: '1rem',
    marginLeft: 0,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '70%'
    }
  },
  iconList: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex'
    }
  }
}));

const DisplaySearchItem = ({ item, index, contents, setOpen, query }) => {
  const classes = useStyles();

  const value = item?.data?.[0];

  const handleDownload = async value => {
    axios
      .get('/documentation/files/download', {
        params: {
          file_id: value?.id
        },
        responseType: 'blob'
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', value?.original_name);
        document.body.appendChild(link);
        link.click();
      });
  };

  const hairdresser = item?.type === 'hairdresser';
  const content = item?.type === 'content';
  const question = item?.type === 'question';
  const contentPreview = content ? getMediaPreview(value) : null;
  const faqPictogram =
    value?.faq_category?.faq_thematic?.pictogram ||
    value?.faq_thematic?.pictogram ||
    value?.thematic?.pictogram ||
    value?.pictogram;

  return (
    <ListItem
      key={value?.id}
      className={classes.list}
      dense
      button
      onClick={() => setOpen(false)}
      component={LinkTo}
      to={
        hairdresser
          ? `/hairdresser/minisite/${value.id}?tab=parameters`
          : content
          ? `/documentation?brand_id=${value?.brands?.[0].id}&type_id=${value?.categories?.[0]?.type_id}&search=${value?.original_name}&category_id=${value?.categories?.[0]?.id}`
          : question
          ? `/faq?thematic=panel-${value.faq_category?.faq_thematic_id}&category=panelcat-${value.faq_category_id}&question=panelfaq-${value.id}#panelfaq-${value.id}`
          : '/'
      }
    >
      <ListItemAvatar className={classes.avatarList}>
        {hairdresser && (
          <Avatar
            style={{
              backgroundColor: `#${value?.brands?.color_primary}`
            }}
            className={classes.avatar}
            alt={value?.brands?.code.toUpperCase()}
          >
            {value?.brands?.code.toUpperCase()}
          </Avatar>
        )}
        {content &&
          (contentPreview?.kind === 'video' ||
            contentPreview?.kind === 'unknown') && (
          <video
            className={classes.avatar}
            src={getMediaSource(contentPreview.src, 'video')}
            muted
            preload="metadata"
            playsInline
          />
        )}
        {content &&
          contentPreview?.kind !== 'video' &&
          contentPreview?.kind !== 'unknown' && (
          <Avatar
            className={classes.avatar}
            variant="square"
            alt={value?.original_name}
            src={contentPreview?.kind === 'image' ? contentPreview.src : ''}
          />
        )}
        {question &&
          (faqPictogram ? (
            <Avatar
              className={classes.avatar}
              variant="square"
              alt={value?.question}
              src={faqPictogram}
            />
          ) : (
            <FaqIcon />
          ))}
        <div className={classes.fileName}>
          {hairdresser &&
            `${value?.code} - ${!value?.name ? value?.city : value?.name}`}
          {question && value?.question}
          {(content && value?.title?.substring(0, 80)) ||
            value?.original_name?.substring(0, 80)}
        </div>
      </ListItemAvatar>
      {content && (
        <div className={classes.iconList}>
          {/* <IconButton
            className={classes.iconWrapper}
            onClick={() => handleDownload(value)}
          >
            <FiDownload />
          </IconButton> */}
          {/* {value?.thumbnails?.[0]?.filename && (
            <IconButton
              component={Link}
              href={value?.thumbnails?.[0]?.filename}
              rel="noreferrer noopener"
              target="_blank"
              className={classes.iconWrapper}
            >
              <AiFillEye />
            </IconButton>
          )} */}
        </div>
      )}
    </ListItem>
  );
};

export default DisplaySearchItem;
